import { Page } from '../../../../../components/page/page';
import { RestoreModal } from '../../../../../features/restore-modal/restore-modal';
import { ArchiveBranchModal } from './archive-branch-modal/archive-branch-modal';
import { BranchesCards } from './branches-cards/branches-cards';
import { BranchesControls } from './branches-controls/branches-controls';
import { BranchesTable } from './branches-table/branches-table';
import s from './branches.module.css';
import { CreateBranchModal } from './create-branch-modal/create-branch-modal';
import { useBranches } from './use-branches';

export const Branches = () => {
  const {
    place,
    createBranchModal,
    editBranchModal,
    archiveBranchModal,
    t,
    restoreBranch,
    viewStyle,
  } = useBranches();

  return (
    <Page className={s.page}>
      <h2 className={s.title}>
        {t('Филиалы')} ({place?.length})
        <BranchesControls />
      </h2>

      {viewStyle === 'table' ? <BranchesTable /> : <BranchesCards />}

      {createBranchModal.isOpen && (
        <CreateBranchModal onClose={() => createBranchModal.handleCloseModal()} />
      )}
      {editBranchModal.isOpen && (
        <CreateBranchModal onClose={() => editBranchModal.handleCloseModal(['branchId'])} />
      )}
      {archiveBranchModal.isOpen && (
        <ArchiveBranchModal
          onClose={() => archiveBranchModal.handleCloseModal(['branchId', 'branchName'])}
        />
      )}
      <RestoreModal onSubmit={restoreBranch} />
    </Page>
  );
};
